import { Model } from 'modules/core/lib/mobx-rest'

interface IPolicyAuthorization {
  target_id: number | null
  target_resource: string | null
  authorize: boolean
  policy_key: string
}
class PolicyAuthorization extends Model<IPolicyAuthorization> {
  static urlRoot() {
    return '/permissions/permissions'
  }
}

export default PolicyAuthorization
